import client from './main-client';

export const getUserCompaniesApi = (params) => client().get('/user-companies', { params });
export const updateUserCompaniesApi = (params) => client().put(`/user-companies/${params.id}`, params.values);
